import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import CapsuleTab from '@repo/ui/capsule-tab'
import { FeesTwoIcon } from '@repo/ui/icons'
import { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

import UserNavBar from '../../../components/elements/nav-bar'
import { Paths } from '../../../lib/constants/path'
import NotFoundPage from '../../common/not-found'
import FeesCommissionsListPage from './fees-commissions-list'
import FeesHostFamilyPricesListPage from './fees-host-family-prices-list'
import FeesTeflPricesListPage from './fees-tefl-prices-list'

const pathsMapping: Record<number, string> = {
  0: Paths.OL_FEES_COMMISSIONS_LIST_PAGE,
  1: Paths.OL_FEES_HOST_FAMILY_PRICE_LIST_PAGE,
  2: Paths.OL_FEES_TEFL_PRICE_LIST_PAGE
}

const FeesListPage = () => {
  const [activeTab, setActiveTab] = useState(0)
  const { navigate } = useNavigator()
  const { pathname } = useLocation()

  useEffect(() => {
    for (const [index, path] of Object.entries(pathsMapping)) {
      if (pathname.includes(path)) {
        setActiveTab(+index)
        return
      }
    }
  }, [pathname])

  return (
    <div>
      <UserNavBar title={'Fees'} icon={FeesTwoIcon} />
      <div className={'h-4'} />

      <Box>
        <CapsuleTab
          variant="secondary"
          activeTab={activeTab}
          onTabChange={(index) => {
            setActiveTab(index)
            // If the user already navigated to the tab, we don't want to navigate again
            if (pathname.includes(pathsMapping[index])) return
            navigate(pathsMapping[index])
          }}
          tabs={[{ label: 'Commissions' }, { label: `Host family fees` }, { label: 'TEFL fees' }]}
        />

        <Routes>
          <Route
            path={Paths.OL_FEES_COMMISSIONS_LIST_PAGE}
            element={<FeesCommissionsListPage />}
          />
          <Route
            path={Paths.OL_FEES_HOST_FAMILY_PRICE_LIST_PAGE}
            element={<FeesHostFamilyPricesListPage />}
          />
          <Route path={Paths.OL_FEES_TEFL_PRICE_LIST_PAGE} element={<FeesTeflPricesListPage />} />
          <Route path={'/'} element={<Navigate to={Paths.OL_FEES_COMMISSIONS_LIST_PAGE} />} />
          <Route path={'*'} element={<NotFoundPage />} />
        </Routes>
      </Box>
    </div>
  )
}

export default FeesListPage
